export { default as TradesForecast } from "./TradesForecast.svelte";
